import React from 'react'
import DataTag from './DataTag'


import '../App.css'
import '../styles/container.scss'
import '../styles/main.scss'
import '../styles/neighborhood.scss'
import '../styles/mapkey.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function DistrictFinder(props) {
    const historicStr = () => {
        if (props.historic === undefined || props.historic === null){
            return "N/A"
        } else {
            const str = props.historic;
            const newStr = str.split(' ').filter(element => element !== 'Historic').filter(element => element !== 'District').join(' ');
            return newStr;
        }
    }

    const panelStyle = () => {
        if (props.panel.district){
            return {
                position: 'absolute',
                zIndex: '2',
                height: '73vh',
                width: '23em',
            }
        }
    }
    const contentStyle = () => {
        if (props.panel.district){
            return {
                overflowY: 'scroll',
                height: '90%',
            }
        }
    }
    return (
        <div className="component" style={panelStyle()}>
            <div className="card-header">
                <div className="header-front">
                <FontAwesomeIcon icon={['fa', 'stamp']} size="2x" className="font-awesome-spacing"/>
                    <h2 className="text-header">District</h2>
                </div>
                    <button id="district" onClick={props.expandClick} className="expand-icon">
                            {props.panel.district ? 
                             <FontAwesomeIcon icon={['fa', 'minus']} className="font-awesome-win"/> :
                             <FontAwesomeIcon icon={['far', 'window-maximize']} className="font-awesome-win"/>
                            }
                    </button>

            </div>

            <div className="card-content" style={contentStyle()}>
                <DataTag 
                    heading1={"Zoning District"}
                    content1={props.district === undefined ? "N/A" : props.district}
                    heading2={"Historic District"}
                    content2={historicStr()}
                />
                <h3 className="text-light">Description</h3>
                <br/>
                {props.description === undefined ? <h2 className="text-bold">- -</h2> : <p className="text-para">{props.description}</p>}
                <br/>
                <h3 className="text-light">Diagram</h3>
                {props.diagram ? <img className="img-diagram" width="90%" alt="img-diagram" src={props.diagram} /> : <h2 className="text-bold">N/A</h2>}
                <br/>
        
                <h3 className="text-light">Further Reading</h3>
                <br/>
                <a className="hyperlink"
                        href={props.reading}
                        rel="noreferrer noopener"
                        target="_blank">
                        Read More
                    </a>
            </div>
        </div>
    )

}